export const WEBSOCKET_TYPE_CUSTOM_FORM_PUBLIC_LINK = 'fp_custom_form_public_link' as const;

export enum CustomFormPublicLinkWebsocketMessageAction {
  PDF_GENERATION_PROGRESS = 'pdf_generation_progress',
  PDF_GENERATED = 'pdf_generated',
  PDF_GENERATION_ERROR = 'pdf_generation_error',
}